import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import InvoiceType from '../models/InvoiceType';

interface IAddInvoiceDocumentDialogProps {
    dialogName: string;
    invoiceDocumentTypes: Array<InvoiceType>;
    handleAddDocument?: (type: string, fileBlob: Blob) => void;
    hideDialog: () => void;
}

const AddInvoiceDocumentDialog = (props: IAddInvoiceDocumentDialogProps) => {
    const { register, errors, getValues } = useForm();
    const [fileBlob, setFileBlob] = useState<Blob>();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('AddInvoiceDocumentDialog onCreate()');
    };

    const OKClicked = () => {
        let values = getValues();
        props?.handleAddDocument(values.addDocument.documentType as string, fileBlob);
        props.hideDialog();
    };

    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const blob = e.target.files[0];
        setFileBlob(blob);
    };      

    return (
        <Dialog title="Add Document" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '25%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFSelect
                        id={``}
                        name={`addDocument.documentType`}
                        label="Document Type:"
                        labelOnLeft={true}
                        labelStyle={{ width: '20rem', margin: '0'}}
                        options={props.invoiceDocumentTypes?.map(id => {
                            return { value: id.documentType, label: id.description };
                            })}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30rem', marginTop: '1rem' }}
                    />
                    <div className="form-row">
                        <RHFInputBox
                            label={'File:'}
                            labelOnLeft={true}
                            labelStyle={{ width: '17rem', margin: '0'}}
                            name={`addDocument.filename`}
                            type="file"
                            register={register}
                            errors={errors}
                            style={{ width: '100%', margin: '0' }}
                            bodyStyle={{ width: '40rem' }}
                            onChange={handleFileSelect}
                        />
                    </div>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ whiteSpace: 'nowrap', width: '26%', marginRight: '1rem' }}
                    text={'Add Document'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
                </Dialog>
    );
};

export default AddInvoiceDocumentDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/AddDocumentDialog.tsx